import React from 'react';
import * as S from './IconSVG.styled';

enum SIZES {
  xSmall = 16,
  small = 22,
  medium = 30,
  large = 36,
  xLarge = 48,
}

interface Props {
  children: React.ReactNode;
  id?: string;
  name?: string;
  testId?: string;
  className?: string;
  style?: unknown;
  size?: SIZES | '' | undefined;
  width?: number;
  height?: number;
}

export function IconSVG({
  children,
  id,
  testId,
  name,
  style,
  className,
  size,
  width,
  height,
  ...props
}: Props) {
  const calculatedWidth = SIZES[size] || width;
  const calculatedHeight = SIZES[size] || height;

  return (
    <S.IconSVG
      id={id}
      $testId={testId}
      $iconName={name}
      className={className}
      style={style}
      $width={calculatedWidth}
      $height={calculatedHeight}
      aria-hidden={true}
      {...props}
    >
      {children}
    </S.IconSVG>
  );
}
